<div class="booking-container" *ngIf="!loader && businessListData.length > 0">
  <div class="heading_sert">
    <h3>New Booking / Query</h3>
</div>
<div class="chip_services_list">
  <mat-chip-listbox class="example-chip">
    <mat-chip (click)="selectBusiness(i)" *ngFor="let item of businessListData; let i =index" [ngClass]="{'Graceful-box-active': item.isSelected == 1}" >{{item.name}}</mat-chip>
 </mat-chip-listbox>
</div>
    <div class="row">
      <div class="col-md-12">
        <mat-card appearance="outlined" class="booking-form" *ngIf="selectedBusiness.revenue_model == 1 && !isLocationVisible">
          <div class="serv_heading">
            <h3>Create {{operationType == 1 ? 'membership query' : 'booking'}} for {{selectedBusiness.name}}</h3>
            <p>{{selectedBusiness.address_line}}</p>
        </div>
  
        <div class="form-group">

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Name</mat-label>
            <input [(ngModel)]="newbookingData.customerName" matInput type="text" placeholder="Enter name" (keyup)="searchCustomerName($event)" [matAutocomplete]="auto">
            <button
          mat-button
          *ngIf="loaderForAutocomplete"
          matSuffix
          aria-label="Clear"
        >
        <mat-progress-spinner
        diameter="20"
        mode="indeterminate"
        color="accent"
        strokeWidth="3"
        style="width: 20px; height: 20px;"
      > </mat-progress-spinner>
        </button>
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option
                *ngFor="let item of autocompleteItems"
                (click)="selectSearchResult(item)"
              >
                {{ item.name | titlecase }} ({{item.country_code}} {{item.phone}})
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
  
          <div class="c_sectionmj">
           <div class="row">
            <div class="col-sm-3">
            <mat-form-field appearance="outline" class="country-code">
              <mat-label>Country Code</mat-label>
              <mat-select
              [(ngModel)]="selectedCountryCode"
              required
              (selectionChange)="onCountrySelected($event)"
            >
              <mat-select-trigger>
                {{ selectedCountryCode.flag }} {{ selectedCountryCode.name }}
                    {{ "(" + selectedCountryCode.dial_code + ")" }}
              </mat-select-trigger>
              
              <mat-option>
                <ngx-mat-select-search
                  noEntriesFoundLabel="no results found"
                  name="countrysearch"
                  placeholderLabel="Enter country name"
                  [formControl]="searchString"
                  (keyup)="onKey()"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let country of countryList" [value]="country">
                {{ country.flag }} {{ country.name }}
                {{ "(" + country.dial_code + ")" }}
              </mat-option>
            </mat-select>
            </mat-form-field>
          </div>
          <div class="col-sm-9">
            <mat-form-field appearance="outline" class="phone-number">
              <mat-label>Phone</mat-label>
              <input matInput 
              [(ngModel)]="newbookingData.customerPh"
              
              type="tel"
              smNumericOnly
              minLength="3"
              maxlength="17" placeholder="Enter phone number">
              <mat-hint
                style="color: red; font-size: 13px"
                align="end"
                *ngIf="
                  newbookingData.customerPh &&
                  newbookingData.customerPh != '' &&
                  newbookingData.customerPh.length < 3 
                "
                >Enter a valid phone number.</mat-hint
              >
            </mat-form-field>
            </div>
          </div>
          </div>
           <div class="c_sectionmj">
            <div class="row">
              <div class="col-sm-12" *ngIf="operationType == 1">
                <mat-form-field appearance="outline" class="phone-number">
                  <mat-label>Email</mat-label>
                  <input matInput [(ngModel)]="newbookingData.email" />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <h3 class="servicet_heading">Operation type</h3>
        <div class="form-group service-button">
          <mat-chip-listbox class="example-chip">
            <mat-chip
              [ngClass]="{ 'Graceful-box-active': operationType == 2 }"
              (click)="changeOperationType(2)"
              >Booking</mat-chip
            >
            <mat-chip
              [ngClass]="{ 'Graceful-box-active': operationType == 1 }"
              (click)="changeOperationType(1)"
              >Membership query</mat-chip
            >
          </mat-chip-listbox>
        </div>

        <div class="web_rr">
        <h3 class="servicet_heading">Service type</h3>
        <div class="form-group service-button">
            <mat-chip-listbox class="example-chip">
                <mat-chip *ngIf="selectedBusiness.shop_service_status != 2 && getSectionVisibleStatus('shop_bookings_access')" [ngClass]="{ 'Graceful-box-active': selectedServiceType == '1' }" (click)="changeServiceType('1')">Shop service</mat-chip>
                <mat-chip *ngIf="selectedBusiness.home_service_status != 2 && getSectionVisibleStatus('home_bookings_access')" [ngClass]="{ 'Graceful-box-active': selectedServiceType == '0' }" (click)="changeServiceType('0')">Home service</mat-chip>
                <mat-chip *ngIf="selectedBusiness.virtual_service_status != 2 && getSectionVisibleStatus('virtual_bookings_access')" [ngClass]="{ 'Graceful-box-active': selectedServiceType == '2' }" (click)="changeServiceType('2')">Virtual service</mat-chip>
            </mat-chip-listbox>
        </div>
      </div>

      <h3 class="servicet_heading">Date and time</h3>
        <div class="form-group date-buttons">
            <mat-chip-listbox class="example-chip">
                <mat-chip  [ngClass]="{ 'Graceful-box-active': selectedBookingType == 1 }"
                (click)="changeChip(1)">Today</mat-chip>
                <mat-chip  [ngClass]="{ 'Graceful-box-active': selectedBookingType == 4 }"
                (click)="changeChip(4)">Tomorrow</mat-chip>
                <mat-chip  [ngClass]="{ 'Graceful-box-active': selectedBookingType == 5 }"
                (click)="onSelectDate()">{{ selectedDate && selectedBookingType == 5 ? (selectedDate | date : "longDate") : "Select Date" }}</mat-chip>
                <mat-chip [ngClass]="{ 'Graceful-box-active': startTime && endTime }" (click)="onSelectSlot()">{{ (startTime && endTime) ? tConv24(startTime) + ' - ' + tConv24(endTime) : 'Select Slot' }}</mat-chip>
            </mat-chip-listbox>
        </div>


        <div class="form-group shop_serv">
            <h3>{{ selectedServiceType == "1" ? "Shop services" : (selectedServiceType == "0" ? "Home services" : "Virtual services") }}</h3>
            <mat-chip-listbox class="example-chip" *ngIf="serviceList.length > 0">
              <div *ngFor="let item of serviceList">
                <mat-chip
                  *ngIf="item.toShow"
                  
                  (click)="selectServices(item)"
                  >{{ item.serviceName }}
                </mat-chip>
              </div>
           
    
            </mat-chip-listbox>
            <p *ngIf="serviceList.length == 0">No service added</p>
        </div>

        <div class="form-group shop_serv" style="border-top: none; margin-top: 0px; padding-top: 0px;" *ngIf="productsList.length > 0">
            <h3>Sellable products</h3>
            <mat-chip-listbox class="example-chip" *ngIf="productsList.length > 0">
              <div *ngFor="let item of productsList">
                <mat-chip
                  *ngIf="item.toShow"
                  
                  (click)="selectProducts(item)"
                  >{{ item.product_name }}
                </mat-chip>
              </div>
           
    
            </mat-chip-listbox>
            <p *ngIf="productsList.length == 0">No products added</p>
        </div>
  

      
  
        <div class="form-group selected-services" *ngIf="selectedJobs.length > 0">
          <h3>Selected services:</h3>
        <div class="open_segnj" *ngFor="let item of selectedJobs; let i = index;">
         <div class="cut_salonm">
          <mat-chip class="Graceful-box-active">{{ item.serviceName }}</mat-chip>
        </div>
        <!-- <mat-icon class="serv_x">close</mat-icon> -->
        <div class="inc_dec_cont">

          <div class="cont_span">
            <button
            class="inc_dec_btn"
            (click)="decreaseServiceCount(item,i)"
            >
            <mat-icon >remove</mat-icon>
            </button>
            <span style="margin: 0 15px;"> {{item.selectedCount}} </span>
            <button 
            class="inc_dec_btn"
            (click)="increaseServiceCount(item,i)"
            >
            <mat-icon class="material-icons-outlined">add</mat-icon>
            </button>
          </div>

          <div class="remove_btn">
          <a (click)="removeSelectedJobs(item)" style="color: #222;"> Remove</a> 
          </div>
        </div>
        </div>
        </div>
  
        <div class="form-group selected-services" *ngIf="selectedProducts.length > 0">
          <h3>Products selected:</h3>
        <div class="open_segnj" *ngFor="let item of selectedProducts; let i = index;">
        <div class="cut_salonm">
          <mat-chip class="Graceful-box-active">{{ item.product_name }}</mat-chip>
        </div>
        <!-- <mat-icon class="serv_x">close</mat-icon> -->
        
        <div class="inc_dec_cont">
          <div class="cont_span">
            <button class="inc_dec_btn" (click)="decreaseProductCount(item,i)">
            <mat-icon>remove</mat-icon>
            </button>
            <span style="margin: 0 15px;"> {{item.selectedCount}} </span>
            <button class="inc_dec_btn" (click)="increaseProductCount(item,i)">
                <mat-icon class="material-icons-outlined">add</mat-icon>
            </button>
          </div>
          <div class="remove_btn">
          <a (click)="removeSelectedProducts(item)"> Remove</a> 
          </div>
        </div>

        </div>
        </div>



   <!-- create invice new design added -->
   <div class="other_itemi_secty">
    <div class="oth_headingrt">
      <h3>Other items</h3>
    </div>
    <form [formGroup]="form">
      <div formArrayName="items">
        <div *ngFor="let item of items.controls; let i = index" [formGroupName]="i" class="repect_under">
          <div class="row">
            <div class="col-sm-3">
              <div class="item_name_tht">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Item name</mat-label>
                  <input matInput formControlName="name" [matAutocomplete]="auto" type="text" placeholder="Enter item name">
                  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayItemName">
                    <mat-option *ngFor="let option of filteredOptions[i] | async" [value]="option">
                      {{ option.item_name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-3">
              <mat-form-field appearance="outline" >
                <mat-select class="w-100" formControlName="tax_slab">
                            <mat-option value="default" >
                              Select a tax
                            </mat-option>
                            <mat-option [value]="item.hash_id" *ngFor="let item of taxSlabData">
                              {{isEntityForeign == '0' ? item.tax_name : item.slab_name}}
                            </mat-option>
                          </mat-select>
             </mat-form-field>
            </div>

            <div class="asa">

          <div class="plus_tht newclassw">
              <div class="flexsc">
                <div class="inc_dec_cont newinc">
                  <span class="cont_span" style="top: 0px;border: 1px solid #a2a2a2;padding: 13px !important;border-radius: 10px; position: relative; bottom: 0px;  width: 125px; display: block;  margin-right: 10px;">
                    <button class="inc_dec_btn" type="button"  (click)="decreaseCount(i)">
                      <mat-icon>remove</mat-icon>
                    </button>
                    <span style="margin: 0 15px;">{{ item.get('count')!.value }}</span>
                    <button class="inc_dec_btn" type="button"  (click)="increaseCount(i)">
                      <mat-icon>add</mat-icon>
                    </button>
                  </span>
                </div>
                </div>

                <div class="item_name_tht itempricex">
                  <mat-form-field appearance="outline" class="full-width" >
                    <mat-label>Item price</mat-label>
                    <input matInput formControlName="price" placeholder="Enter item price" smDecimalOnly  type="number" >
                  </mat-form-field>
                </div>
              </div>
            </div>


           
            <!-- <div class="col-sm-3">
            
            </div> -->
            <span class="remove_btn">

              <a (click)="removeFormField(i)"> Remove</a>

              </span>
          </div>
        </div>
      </div>
    
      <div class="add_item_btbh">
        <button mat-flat-button color="accent" type="button" (click)="addFormField()">
          <mat-icon>add</mat-icon>
          Add item
        </button>
      </div>
    </form>
    

  </div>


  <!-- create invice new design end -->




  
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Cost</mat-label>
          <input matInput 
          [(ngModel)]="formattedPrice"
          [disabled]="true" type="text" placeholder="Enter cost">
        </mat-form-field>
  
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Notes</mat-label>
          <textarea [(ngModel)]="newbookingData.note" matInput placeholder="Enter additional notes"></textarea>
        </mat-form-field>
        <div class="cabh_sect">
        <!-- <button mat-flat-button class="cccakl">Cancel</button> -->
         <button
            *ngIf="operationType == 1"
            mat-flat-button
            color="accent"
            class="submit-btn"
            (click)="addNewJoiningInterest()"
            [disabled]="formChecker2() || !newbookingData.customerName"
          >
            Create new query
          </button>
        <button mat-flat-button color="accent" class="submit-btn"  *ngIf="
              operationType == 2 &&
              (selectedServiceType == '1' || selectedServiceType == '2')
            "
        (click)="onPost()"
        [disabled]="selectedJobs.length == 0 || formChecker()">Create new booking</button>
        <button
             *ngIf="operationType == 2 && selectedServiceType == '0'"
            mat-flat-button
            color="accent"
            class="submit-btn"
            (click)="gotoaddressorToggle()"
            [disabled]="selectedJobs.length == 0 || formChecker()"
          >
            Next
          </button>
      </div>
    </mat-card>




<!-- -------------------------------------------------------------------------------- -->
<!-- -------------------------------------------------------------------------------- -->
<!-- ------------------JOINING QUERY SECTION FOR FITNESSS BELOW---------------------- -->
<!-- -------------------------------------------------------------------------------- -->
<!-- -------------------------------------------------------------------------------- -->





        <mat-card appearance="outlined" class="booking-form" *ngIf="selectedBusiness.revenue_model == 2 && !isLocationVisible">
          <div class="serv_heading">
            <h3>Create {{operationType == 1 ? 'membership query' : 'session booking'}} for {{selectedBusiness.name}}</h3>
            <p>{{selectedBusiness.address_line}}</p>
        </div>

        <mat-form-field appearance="outline" class="full-width">
        <mat-label>Name</mat-label>
          <input [(ngModel)]="newbookingData.customerName" matInput type="text" placeholder="Enter name" (keyup)="searchCustomerName($event)" [matAutocomplete]="auto">
          <button
        mat-button
        *ngIf="loaderForAutocomplete"
        matSuffix
        aria-label="Clear"
      >
      <mat-progress-spinner
      diameter="20"
      mode="indeterminate"
      color="accent"
      strokeWidth="3"
      style="width: 20px; height: 20px;"
    > </mat-progress-spinner>
      </button>
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option
              *ngFor="let item of autocompleteItems"
              (click)="selectSearchResult(item)"
            >
              {{ item.name | titlecase }} ({{item.country_code}} {{item.phone}})
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <div class="c_sectionmj">
         <div class="row">
          <div class="col-sm-3">
          <mat-form-field appearance="outline" class="country-code">
            <mat-label>Country Code</mat-label>
            <mat-select
            [(ngModel)]="selectedCountryCode"
            required
            (selectionChange)="onCountrySelected($event)"
          >
            <mat-select-trigger>
              {{ selectedCountryCode.flag }} {{ selectedCountryCode.name }}
                  {{ "(" + selectedCountryCode.dial_code + ")" }}
            </mat-select-trigger>
            
            <mat-option>
              <ngx-mat-select-search
                noEntriesFoundLabel="no results found"
                name="countrysearch"
                placeholderLabel="Enter country name"
                [formControl]="searchString"
                (keyup)="onKey()"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let country of countryList" [value]="country">
              {{ country.flag }} {{ country.name }}
              {{ "(" + country.dial_code + ")" }}
            </mat-option>
          </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-9">
          <mat-form-field appearance="outline" class="phone-number">
            <mat-label>Phone</mat-label>
            <input matInput 
            [(ngModel)]="newbookingData.customerPh"
            
            type="tel"
            smNumericOnly
            minLength="3"
                  maxlength="17" placeholder="Enter phone number">
            <mat-hint
              style="color: red; font-size: 13px"
              align="end"
              *ngIf="
                newbookingData.customerPh &&
                newbookingData.customerPh != '' &&
                newbookingData.customerPh.length < 3
              "
              >Enter a valid phone number.</mat-hint
            >
          </mat-form-field>
          </div>
           <div class="col-sm-12" *ngIf="operationType == 1">
          <mat-form-field appearance="outline" class="phone-number">
            <mat-label>Email</mat-label>
            <input matInput 
            [(ngModel)]="newbookingData.email"
            
            >
          </mat-form-field>
          </div>
        </div>

        </div>

        <h3 class="servicet_heading">Operation type</h3>
        <div class="form-group service-button">
          <mat-chip-listbox class="example-chip">
            <mat-chip  [ngClass]="{ 'Graceful-box-active': operationType == 2 }" (click)="changeOperationType(2)">Session booking</mat-chip>
            <mat-chip  [ngClass]="{ 'Graceful-box-active': operationType == 1 }" (click)="changeOperationType(1)">Membership query</mat-chip>
             
          </mat-chip-listbox>
      </div>

       


        <h3 class="servicet_heading">Service type</h3>
        <div class="form-group service-button">
          <mat-chip-listbox class="example-chip">
              <mat-chip *ngIf="selectedBusiness.shop_service_status != 2 && getSectionVisibleStatus('shop_bookings_access')" [ngClass]="{ 'Graceful-box-active': selectedServiceType == '1' }" (click)="changeServiceType('1')">In-premise service</mat-chip>
              <mat-chip *ngIf="selectedBusiness.home_service_status != 2 && getSectionVisibleStatus('home_bookings_access')" [ngClass]="{ 'Graceful-box-active': selectedServiceType == '0' }" (click)="changeServiceType('0')">Home service</mat-chip>
              <mat-chip *ngIf="selectedBusiness.virtual_service_status != 2 && getSectionVisibleStatus('virtual_bookings_access')" [ngClass]="{ 'Graceful-box-active': selectedServiceType == '2' }" (click)="changeServiceType('2')">Virtual service</mat-chip>
          </mat-chip-listbox>
      </div>
        <h3 class="servicet_heading" *ngIf="operationType == 2">Date and time</h3>
        <div class="form-group date-buttons" *ngIf="operationType == 2">
            <mat-chip-listbox class="example-chip">
                <mat-chip  [ngClass]="{ 'Graceful-box-active': selectedBookingType == 1 }"
                (click)="changeChip(1)">Today</mat-chip>
                <mat-chip  [ngClass]="{ 'Graceful-box-active': selectedBookingType == 4 }"
                (click)="changeChip(4)">Tomorrow</mat-chip>
                <mat-chip  [ngClass]="{ 'Graceful-box-active': selectedBookingType == 5 }"
                (click)="onSelectDate()">{{ selectedDate && selectedBookingType == 5 ? (selectedDate | date : "longDate") : "Select Date" }}</mat-chip>
                <mat-chip [ngClass]="{ 'Graceful-box-active': startTime && endTime }" (click)="onSelectSlot()">{{ (startTime && endTime) ? tConv24(startTime) + ' - ' + tConv24(endTime) : 'Select Slot' }}</mat-chip>
            </mat-chip-listbox>
        </div>
 <h3 class="servicet_heading" *ngIf="operationType == 1">Day and time</h3>
        <div *ngIf="operationType == 1">
          <div class="chip_cont"  *ngFor="let item of selectedDays; let i = index">
            <mat-chip-listbox aria-label="Fish selection" class="mb-3 matchp" style="border-bottom: 1px solid #e2e2e2;padding-bottom: 5px;width: 100%;display: block; position: relative;" >
               
                <div>
                  <mat-chip
                  class="selected"
                    
                    
                    >{{ item.day.dayName }}
                  </mat-chip>
                  <mat-chip
                  class="selected"
                    
                    
                    >{{ tConv24(item.startTime) }} - {{tConv24(item.endTime)}}
                  </mat-chip>
                </div>
                <div class="close_heradinrt">
                  <p><a (click)="removeSelectedDay(i)"> Remove</a></p>
                </div>
              </mat-chip-listbox>
            </div>
            <button
            class="add-new-btn"
            (click)="openTimings()"
            mat-flat-button
            color="accent">
          <mat-icon>add</mat-icon>
            Add a day
          </button>

        </div>
<!-- SERVICES -->
      <div class="form-group shop_serv">
        <h3 class="servicet_heading">{{ selectedServiceType == "1" ? "In-premise services" : (selectedServiceType == "0" ? "Home services" : "Virtual services") }}</h3>
        <mat-chip-listbox class="example-chip" *ngIf="serviceList.length > 0">
          <div *ngFor="let item of serviceList">
            <mat-chip
              *ngIf="item.toShow"
              
              (click)="selectServices(item)"
              >{{ item.serviceName }}
            </mat-chip>
          </div>
       

        </mat-chip-listbox>
        <p *ngIf="serviceList.length == 0" style="color: #a6a6a6;">No service added</p>
    </div>


<!-- PRODUCTS -->
      <div class="form-group shop_serv" style="border-top: none;margin-top: 0px;padding-top: 0px;" *ngIf="productsList.length > 0">
        <h3 class="servicet_heading">Sellable Products</h3>
        <mat-chip-listbox class="example-chip" *ngIf="productsList.length > 0">
          <div *ngFor="let item of productsList">
            <mat-chip
              *ngIf="item.toShow"
              
              (click)="selectProducts(item)"
              >{{ item.product_name }}
            </mat-chip>
          </div>
       

        </mat-chip-listbox>
        <p *ngIf="productsList.length == 0" style="color: #a6a6a6;">No product added</p>
    </div>

  
<!-- SELECTED SERVICES -->
    <div class="form-group selected-services" style="margin-bottom: 0px;" *ngIf="selectedJobs.length > 0">
      <h3>Selected services:</h3>
    <div class="open_segnj" *ngFor="let item of selectedJobs; let i = index;">
    <div class="cut_salonm">
      <mat-chip class="Graceful-box-active">{{ item.serviceName }}</mat-chip>
    </div>
    <mat-icon class="serv_x">close</mat-icon>
    <div class="inc_dec_cont">
     
      <span class="cont_span">
        <button
        class="inc_dec_btn"
        (click)="decreaseServiceCount(item,i)">
        <mat-icon >remove</mat-icon>
        </button>
        <span style="margin: 0 15px;"> {{item.selectedCount}} </span>
        <button 
        class="inc_dec_btn"
        (click)="increaseServiceCount(item,i)">
        <mat-icon class="material-icons-outlined">add</mat-icon>
        </button>
      </span>

      <span class="remove_btn">
      <a (click)="removeSelectedJobs(item)" style="color: #222;"> Remove</a>
      </span>
    </div>
    </div>
    </div>


<!-- SELECTED PRODUCTS -->
    <div class="form-group selected-services" *ngIf="selectedProducts.length > 0">
      <h3>Products selected:</h3>

    <div class="open_segnj" *ngFor="let item of selectedProducts; let i = index;">
    <div class="cut_salonm">
      <mat-chip class="Graceful-box-active">{{ item.product_name }}</mat-chip>
    </div>
    <!-- <mat-icon class="serv_x">close</mat-icon> -->

    <div class="inc_dec_cont">
      <span class="cont_span">
        <button
        class="inc_dec_btn"
        (click)="decreaseProductCount(item,i)">
        <mat-icon>remove</mat-icon>
        </button>
        <span style="margin: 0 15px;"> {{item.selectedCount}} </span>
        <button class="inc_dec_btn" (click)="increaseProductCount(item,i)">
        <mat-icon class="material-icons-outlined">add</mat-icon>
        </button>
      </span>
      <span style="color: #222;" class="remove_btn" (click)="removeSelectedProducts(item)">
        Remove
      </span>
    </div>


    </div>

    </div>


   <!-- create invice new design added -->
   <div class="other_itemi_secty">
    <div class="oth_headingrt">
      <h3>Other items</h3>
    </div>
 
    <form [formGroup]="form">
      <div formArrayName="items">
        <div *ngFor="let item of items.controls; let i = index" [formGroupName]="i" class="repect_under">
          <div class="row">
            <div class="col-sm-3">
              <div class="item_name_tht">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Item name</mat-label>
                  <input matInput formControlName="name" [matAutocomplete]="auto" type="text" placeholder="Enter item name">
                  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayItemName">
                    <mat-option *ngFor="let option of filteredOptions[i] | async" [value]="option">
                      {{ option.item_name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-3">
              <mat-form-field appearance="outline" >
                    <mat-select class="w-100" formControlName="tax_slab">
                            <mat-option value="default" >
                              Select a tax
                            </mat-option>
                            <mat-option [value]="item.hash_id" *ngFor="let item of taxSlabData">
                              {{isEntityForeign == '0' ? item.tax_name : item.slab_name}}
                            </mat-option>
                          </mat-select>
             </mat-form-field>
            </div>

            <div class="asad">

              <div class="plus_tht newclassw">
                   <div class="flexsc">
                <div class="inc_dec_cont newinc">
                  <span class="cont_span" style="top: 2px;border: 1px solid #a2a2a2;padding: 13px !important;border-radius: 10px; position: relative; bottom: 0px;  width: 125px; display: block;  margin-right: 10px;">
                    <button type="button" class="inc_dec_btn"  (click)="decreaseCount(i)">
                      <mat-icon>remove</mat-icon>
                    </button>
                    <span style="margin: 0 15px;">{{ item.get('count')!.value }}</span>
                    <button type="button" class="inc_dec_btn"  (click)="increaseCount(i)">
                      <mat-icon>add</mat-icon>
                    </button>
                  </span>
                </div>
             </div>

              <div class="item_name_tht itempricex">
                <mat-form-field appearance="outline" class="full-width" >
                  <mat-label>Item price</mat-label>
                  <input matInput formControlName="price" placeholder="Enter item price" smDecimalOnly  type="number" >
                </mat-form-field>
              </div>
            </div>
            </div>
            
            <!-- <div class="col-sm-3">
             
            </div> -->
            <span class="remove_btn" (click)="removeFormField(i)" style="color: #222;">Remove</span>
          </div>
        </div>
      </div>
    
      <div class="add_item_btbh">
        <button type="button" mat-flat-button color="accent" (click)="addFormField()">
          <mat-icon>add</mat-icon>
          Add item
        </button>
      </div>
    </form>
    

  </div>


 
          <div>
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Cost</mat-label>
              <input
                [(ngModel)]="formattedPrice"
                matInput
                
                [disabled]="true"
              />
              
            </mat-form-field>
          </div>
          <div>
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Notes</mat-label>
              <textarea [(ngModel)]="newbookingData.note"[maxLength]="400" matInput></textarea>
              <!-- <mat-icon matSuffix class="material-icons-outlined">message</mat-icon> -->
            </mat-form-field>
          </div>
          <div class="cabh_sect">
            <!-- <button mat-flat-button class="cccakl">Cancel</button> -->
           <button *ngIf="operationType == 1" mat-flat-button color="accent" class="submit-btn" 
            (click)="addNewJoiningInterest()"
            [disabled]="formChecker2() || !newbookingData.customerName">Create new query</button>
            
         <button
            *ngIf="operationType == 2 && (selectedServiceType == '1' || selectedServiceType == '2' )"
            mat-flat-button
            color="accent"
            class="submit-btn"
            (click)="onPost()"
            [disabled]="selectedJobs.length == 0 || formChecker()"
          >
            Create new booking
          </button>
          <button
            *ngIf="operationType == 2 && selectedServiceType == '0'"
            mat-flat-button
            color="accent"
            class="submit-btn"
            (click)="gotoaddressorToggle()"
            [disabled]="selectedJobs.length == 0 || formChecker()"
          >
            Next
          </button>
          </div>
    </mat-card>

      <!-- LOCATION ADD FOR HOME BOOKINGS -->
      <mat-card class="booking-form" *ngIf="isLocationVisible">
        <div class="col-sm-12" style="padding: 0">
          <div class="content" style="">
            <!-- <h1>New business creation (step 4 of 4)</h1> -->
            <div class="sub_headingt">
              <!-- <h3></h3> -->
            </div>
            <div class="map-holder">
              <div
                #mapContainer
                id="map-container"
                style="height: 300px; width: 100%"
              ></div>
            </div>
            <div>
        <p style="color: #888; margin-bottom: 30px;">
          Add address where you would like to be served. You can drag the map
          pointer for a precise location. A well defined address will help the
          service provider to locate the address correctly.
        </p>
      </div>
            <div class="map-form-holder">
              <!-- <h4>Address</h4> -->
              <mat-form-field appearance="outline">
                <mat-label>Enter location</mat-label>
                <input
                  (input)="onInputChange()"
                  placeholder="Select a location"
                  [matAutocomplete]="auto"
                  [(ngModel)]="this.formattedAddress"
                  matInput
                  #input
                />
                <mat-autocomplete #auto="matAutocomplete">
                  <mat-option
                    *ngFor="let item of googleAutoCompleteItems"
                    (click)="selectItem(item)"
                  >
                    {{ item.description }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div class="">
              <!-- <h4>Address</h4> -->
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Zipcode</mat-label>
                <input
                  [(ngModel)]="this.selectedLocation.zip"
                  type="text"
                  matInput
                  #input
                />
              </mat-form-field>
            </div>
            <div class="">
              <!-- <h4>Address</h4> -->
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>House number</mat-label>
                <input [(ngModel)]="houseNumber" type="text" matInput #input />
              </mat-form-field>
            </div>
            <div class="">
              <!-- <h4>Address</h4> -->
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Street name</mat-label>
                <input [(ngModel)]="streetName" type="text" matInput #input />
              </mat-form-field>
            </div>
            <div class="">
              <!-- <h4>Address</h4> -->
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Landmark</mat-label>
                <input [(ngModel)]="landmark" type="text" matInput #input />
              </mat-form-field>
            </div>
            <div class="">
              <div class="row g-2 justify-content-between phone-field">
                <mat-form-field appearance="outline" class="country-code col-3">
                  <mat-label>Country Code</mat-label>
                  <mat-select
                    [(ngModel)]="contactselectedCountryCode"
                    required
                    (selectionChange)="onCountrySelected($event)"
                  >
                    <mat-select-trigger>
                      {{ "(" + contactselectedCountryCode.dial_code + ")" }}
                    </mat-select-trigger>

                    <mat-option>
                      <ngx-mat-select-search
                        noEntriesFoundLabel="no results found"
                        name="countrysearch"
                        placeholderLabel="Enter country name"
                        [formControl]="searchString"
                        (keyup)="onKey()"
                      ></ngx-mat-select-search>
                    </mat-option>
                    <mat-option
                      *ngFor="let country of countryList"
                      [value]="country"
                    >
                      {{ "(" + country.dial_code + ")" }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field class="mobile_form col-9" appearance="outline">
                  <mat-label>Contact phone</mat-label>
                  <input
                    matInput
                    type="tel"
                    [(ngModel)]="phone"
                    minLength="3"
                    maxlength="17"
                  />
                  <!-- <mat-hint
        style="color: red; font-size: 13px"
        align="end"
        *ngIf="
          newbookingData.customerPh &&
          newbookingData.customerPh != '' &&
          newbookingData.customerPh.length < 3
        "
        >Enter a valid phone number.</mat-hint 
      >-->
                </mat-form-field>
              </div>
            </div>
          </div>
          <!-- <div class="footer">
      <button mat-button style="font-size: 16px" (click)="onClickBack(4)">
        <mat-icon>arrow_back</mat-icon>
        Back
      </button>
      <button
        (click)="onSubmit()"
        [disabled]="!formattedAddress"
        mat-flat-button
        color="accent"
        class="next"
      >
        Save
      </button>
    </div> -->
        </div>
        <div class="cabh_sect">
          <!-- <button mat-flat-button class="cccakl">Cancel</button> -->
          <button
          style="margin-right: 10px;"
            mat-button
            *ngIf="selectedServiceType == '0' && isLocationVisible"
            (click)="gotoaddressorToggle()"
          >
            Back
          </button>
          <button
            *ngIf="selectedServiceType == '0' && isLocationVisible"
            mat-flat-button
            color="accent"
            class="submit-btn"
            (click)="onPost()"
            [disabled]="
              !formattedAddress ||
              !phone ||
              phone.length < 3 ||
              !selectedLocation.zip
            "
          >
            Create new booking
          </button>
        </div>
      </mat-card>
    </div>
  
   
    </div>

   <!-- Placeholder design html start -->
      <!-- <div class="placeholder_started">
        <div class="row">
          <div class="heading_sert">
            <h3>New booking</h3>
        </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/s3.png">
                 </div>
                 <mat-card-title>No business added yet</mat-card-title>
                 <mat-card-content>To add a new booking, you need to create a business first. Booking will be added and listed under that business.
                </mat-card-content>
                 <div class="create_btnyh">
                    <button mat-flat-button color="primary">
                        <mat-icon>add</mat-icon> 
                        Create new 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/watchvideo.png">
                 </div>
                 <mat-card-title>How to create a new booking?</mat-card-title>
                 <mat-card-content>Check our <span class="ghtunderline">help document<span> on creating new booking against a business. You can check this video as well.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary">
                       <mat-icon>play_arrow</mat-icon>
                       Watch video
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Having any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in adding a new booking or if there's any issue while adding them, contact our support team.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary">
                       <mat-icon>support_agent</mat-icon>
                       Contact support 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
    
      </div> -->
      <!-- Placeholder design html start -->


  </div>
  
<div class="booking-container" *ngIf="!loader && businessListData.length == 0">
   <!-- Placeholder design html start -->
      <div class="placeholder_started">
        <div class="row">
          <div class="heading_sert">
            <h3>New booking</h3>
        </div>
          <div class="col-sm-4" *ngIf="!isEmployeeAndHasBusinessButDoesNotHaveAccess">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/business-create.png" style="width: 110px;">
                 </div>
                 <mat-card-title>No business added yet</mat-card-title>
                 <mat-card-content>To add a new booking, you need to create a business first. Booking will be added and listed under that business.
                </mat-card-content>
                 <div class="create_btnyh">
                    <button mat-flat-button color="primary" (click)="selectcountry()">
                        <mat-icon>add</mat-icon> 
                        Create a business
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4" *ngIf="isEmployeeAndHasBusinessButDoesNotHaveAccess">
            <div class="dashboard_new" >
              <mat-card appearance="outlined" style="height: auto !important;">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/business-create.png" style="width: 110px;">
                 </div>
                 <mat-card-title>Access denied.</mat-card-title>
                 <mat-card-content> Business owner with valid premium business subscription or an active employee with permission can access this section. Check current plans. Recharge pack if expired.
                </mat-card-content>
                 
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/new-booking.png">
                 </div>
                 <mat-card-title>How to create a new booking?</mat-card-title>
                 <mat-card-content>Check our <span class="ghtunderline"><a href="https://lookzup.com/help" target="_blank" class="ghtunderline"> help document </a></span> on creating new booking against a business. You can check this video as well. .
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="openvideo()">
                       <mat-icon>play_arrow</mat-icon>
                       Watch video
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Having any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in adding a new booking or if there's any issue while adding them, contact our support team.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
    
      </div>
      <!-- Placeholder design html start -->


  </div>
  